import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Paper, withStyles, Box, IconButton, Tooltip } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { Refresh } from '@material-ui/icons';

import { parseURL, BackButton, hasPermission, formatDate } from '../../sc-utilities';
import config from '../../../config/config';

import { snackActions } from '../../sc-utilities/SnackBar';
import * as pcProductActions from '../PCProduct/store/pcProductActions';
import { downloadFile, updateURL } from '../../sc-utilities';
import { getMediaArrays } from '../../sc-media/utilities';

import * as baseboardActions from '../../sc-productComponents/Baseboard/store/baseboardActions';
import * as batteryActions from '../../sc-productComponents/Battery/store/batteryActions';
import * as cpuActions from '../../sc-productComponents/CPU/store/cpuActions';
import * as gpuActions from '../../sc-productComponents/GPU/store/gpuActions';
import * as memoryActions from '../../sc-productComponents/Memory/store/memoryActions';
import * as nicActions from '../../sc-productComponents/NIC/store/nicActions';
import * as storageActions from '../../sc-productComponents/Storage/store/storageActions';
import ProductDontLoading from '../ProductDontLoading';

import ProductDetails from './PCProductEditDetails';
import ProductMisc from './Details/PCProductEditMisc';
import MediaGallery from '../../sc-media/MediaGallery';
import CPUList from '../../sc-productComponents/CPU';
import StorageList from '../../sc-productComponents/Storage';
import Report from '../../sc-productComponents/Report';
import GPUList from '../../sc-productComponents/GPU';
import BaseboardList from '../../sc-productComponents/Baseboard';
import NICList from '../../sc-productComponents/NIC';
import MemoryList from '../../sc-productComponents/Memory';
import BatteryList from '../../sc-productComponents/Battery';
import {useChangeActiveCustomerModalHook} from "../hooks/useChangeActiveCustomerModalHook";
import StatisticModal from "../../sc-dashboard/Statistic/StatisticModal";
import {handleChangeCustomer} from "../../sc-dashboard/Statistic";
import * as action from "../../np-dashboard/CustomerBar/store/actions";
import Diagnose from "../../sc-diagnose/Diagnose";
import WorkProductAuditRecord from '../../sc-productComponents/WorkProductAuditRecord';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',

        margin: theme.spacing(),

        [theme.breakpoints.down('md')]: {
            width: `97.8%`
        },
        [theme.breakpoints.down('sm')]: {
            width: `97.8%`
        }
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 6, marginTop: '1%' }}>
            {props.children}
        </Typography>
    );
};

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {((value === index || value < 5)) && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const ProductComponents = props => {
    const { classes, theme, activeCustomer, productEditable, onFetchPCProduct, permissions, onCleanBaseboard, onGenerateReportPc, translations, onCleanCpu, onCleanGpu, onCleanMemory, onCleanNic, onCleanStorage, pcProducts, onCleanPCState, onChangeActiveCustomer } = props;
    let searchParams = parseURL(window.location.search);
    const [tabValue, setTabValue] = useState(getTabValue());
    const [editable, setEditable] = useState({ editable: false, loading: false });
    const [signatures, setSignatures] = useState([]);
    const [mediaArrays, setMediaArrays] = useState({ videoArray: [], audioArray: [], imageArray: [] });
    const [deletedMedia, setDeletedMedia] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [redirectOptions, setRedirectOptions] = useChangeActiveCustomerModalHook(searchParams, activeCustomer);

    useEffect(() => {
        const fetchData = async () => {
            let isEditable = await productEditable({ ProductID: searchParams.productID, ActiveCustomerID: activeCustomer });
            setEditable({ editable: isEditable.productEditable, loading: true });
        }
        fetchData();
        return () => { };
    }, [activeCustomer, productEditable, searchParams.productID]);

    useEffect(() => {
        return () => {
            onCleanPCState();
            onCleanBaseboard();
            onCleanCpu();
            onCleanGpu();
            onCleanMemory();
            onCleanNic();
            onCleanStorage();
        };
    }, [onCleanPCState, onCleanBaseboard, onCleanCpu, onCleanGpu, onCleanMemory, onCleanNic, onCleanStorage]);

    useEffect(() => {

        if (pcProducts && pcProducts.loaded && pcProducts.loaded.Media && pcProducts.loaded.Media.length > 0) {
            const media = getMediaArrays(pcProducts.loaded.Media);
            setMediaArrays({ imageArray: media.tempImages, videoArray: media.tempVideos, audioArray: media.tempAudio });
        }

        if (pcProducts && pcProducts.loaded && pcProducts.loaded.Signatures && pcProducts.loaded.Signatures.length > 0) {
            let tempSignatures = [];
            const signaturePath = `${config.backend_domain}:${config.backend_port}/static-signature/`;

            pcProducts.loaded.Signatures.forEach((signature) => {
                if (!signature.Deleted) {
                    tempSignatures.push({
                        id: signature.SignatureID,
                        path: signaturePath + signature.ImageLocation,
                        type: 'signature',
                        createdAt: signature.CreatedAt ? formatDate(signature.CreatedAt) : ''
                    });
                }
            });
            setSignatures(tempSignatures);
        }
    }, [pcProducts]);

    const unlockEdit = () => {
        setEditable({ editable: true, loading: true });
        snackActions.snackBarComponent(`${translations['cant_edit_data_text'] || 'Now you can edit data, but it will be overwritten with latest request from QT'}.`, 'warning');
    }
    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    const getPCLogData = async () => {
        let data = await props.onPCDownload(searchParams.productID, { ActiveCustomerID: activeCustomer });
        if (data?.status !== 200) {
            return snackActions.snackBarComponent(data?.message ?? `${translations['not_find_session'] || 'Could not find session data'}!`, 'error');
        }
        if (data) {
            return downloadFile(data.blob, data.fileName);
        }
    };
    let disabled = (typeof pcProducts?.loaded === 'boolean' && !pcProducts?.loaded);

    // const fetchPCProduct = () => {
    //     onFetchPCProduct({ActiveCustomerID: activeCustomer, ProductID: searchParams?.productID});
    // }

    return (
        <div>
            {!redirectOptions.open && <>
            <Paper className={classes.root}>
                {disabled ? null : BackButton(translations)}
                {tabValue < 5 && tabValue !== 2 ? <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} disabled={disabled} component="div" onClick={() => setRefresh(true)}>
                        <Refresh />
                    </IconButton>
                </Tooltip> : null}
                {
                    searchParams.type === 'PCProduct' ?
                        <Tabs
                            value={tabValue}
                            onChange={handleChange}
                            style={{ padding: 0 }}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="on"
                        >
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["details"] || "Details"} value={0} /> : null}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["misc"] || "MISC"} value={1} /> : null}
                            {hasPermission(permissions, 'product_audit_record_list') ? <Tab disabled={disabled} label={translations["audit_record"] || "Audit Record"} value={13}/> : null}
                            {hasPermission(permissions, 'erasure_report_list') ? <Tab disabled={disabled} label={translations["reports"] || "Reports"} value={2} /> : null}
                            {hasPermission(permissions, 'diagnose_case_round_results_list') && <Tab disabled={disabled} label={translations["diagnose"] || "Diagnose"} value={12} />}
                            {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["media"] || "Media"} value={3} /> : null}
                            {/* {hasPermission(permissions, 'product_load') ? <Tab disabled={disabled} label={translations["presets"] || "Presets"} value={4} /> : null} */}

                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["storages"] || "Storages"} value={5} /> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["memories"] || "Memories"} value={6} /> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["cpus"] || "CPUs"} value={7} /> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["baseboards"] || "Baseboards"} value={8} /> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["gpus"] || "GPUs"} value={9} /> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["nics"] || "NICs"} value={10} /> : null}
                            {hasPermission(permissions, 'component_list') ? <Tab disabled={disabled} label={translations["batteries"] || "Batteries"} value={11} /> : null}

                        </Tabs>
                        : null
                }
            </Paper>
            {
                searchParams.type === 'PCProduct' ?
                    <>
                        { hasPermission(permissions, 'product_load') && editable.loading ?
                            <TabPanel index={0} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue < 5 ? <ProductDetails onFetchPCProduct={onFetchPCProduct} deletedMedia={deletedMedia} setDeletedMedia={setDeletedMedia} setRefresh={setRefresh} refresh={refresh} setEditable={setEditable} translations={translations} tabValue={tabValue} onUnpairBulkExternalPC={props.onUnpairBulkExternalPC} onUnpairExternalPC={props.onUnpairExternalPC} editable={editable.editable} permissions={permissions} unlockEdit={unlockEdit} productEditable={props.productEditable} fetchCollies={props.fetchCollies} moveToAnotherPalette={props.movePCToAnotherPalette} fetchOrders={props.fetchPCOrders} onLoadedCleanup={props.pcProductEditInit} onDeleteProduct={props.onDeletePCProduct} getLogData={getPCLogData} onEditProduct={props.onEditPCProduct} fetchTypicalProblems={props.onFetchPCTypicalProblems} fetchGrades={props.onFetchPCGrades} fetchGradingCategories={props.onFetchPCGradingCategories} productID={searchParams.productID} type={searchParams.type} product={props.pcProducts} onFetchProduct={props.onFetchPCProduct} /> : <ProductDontLoading />}</TabContainer> </TabPanel> : <></>}
                        {hasPermission(permissions, 'product_load') && editable.loading ?
                            <TabPanel index={1} value={tabValue}>   <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue < 5 ? <ProductMisc refresh={refresh} translations={translations} activeCustomer={activeCustomer} editable={editable.editable} unlockEdit={unlockEdit} permissions={permissions} productID={searchParams.productID} product={props.pcProducts.loaded} onEditProduct={props.onEditPCProduct} /> : <ProductDontLoading />}</TabContainer></TabPanel> : <></>}
                        { hasPermission(permissions, 'product_audit_record_list') && editable.loading ? 
                            <TabPanel index={13} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue === 13 ? <WorkProductAuditRecord refresh={refresh} translations={translations} activeCustomer={activeCustomer} permissions={permissions} editable={editable.editable} productID={searchParams.productID} product={props.pcProducts.loaded}  /> : <ProductDontLoading />} </TabContainer>  </TabPanel > : <></>}

                        {hasPermission(permissions, 'erasure_report') && editable.loading ?
                            <TabPanel index={2} value={tabValue}>
                                <TabContainer dir={theme.direction}>{!disabled && tabValue === 2 ? <Report onGenerate={onGenerateReportPc} tabValue={tabValue} productID={searchParams.productID} productType="PCProduct"/> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'product_load') && editable.loading ?
                            <TabPanel index={3} value={tabValue}>  <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue < 5 ? <MediaGallery productID={searchParams.productID} refresh={refresh} onRefresh={() => setDeletedMedia(true)} entity={translations['product'] || 'Product'} translations={translations} images={mediaArrays.imageArray} videos={mediaArrays.videoArray} audio={mediaArrays.audioArray} signatures={signatures} permissions={permissions} /> : <ProductDontLoading />}</TabContainer> </TabPanel> : <></>}
                        {/* {hasPermission(permissions, 'product_load') && editable.loading ? <TabPanel index={4} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 4 ?
                            <Presets loadPresets={fetchPCProduct} updatePresets={onUpdatePresets} loadedPreset={pcProducts.loaded} idParams={{ProductID: searchParams?.productID}}  /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>} */}

                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={5} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 5 ? <StorageList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={6} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 6 ? <MemoryList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={7} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 7 ? <CPUList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={8} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 8 ? <BaseboardList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={9} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 9 ? <GPUList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={10} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 10 ? <NICList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        {hasPermission(permissions, 'component_list') && editable.loading ? <TabPanel index={11} value={tabValue}>
                            <TabContainer dir={theme.direction}>{!disabled && tabValue === 11 ? <BatteryList translations={translations} tabValue={tabValue} productID={searchParams.productID} permissions={permissions} editable={editable.editable} /> : <ProductDontLoading />} </TabContainer>    </TabPanel> : <></>}
                        { hasPermission(permissions, 'diagnose_case_round_results_list') && editable.loading ?
                            <TabPanel index={12} value={tabValue}> <TabContainer style={{ padding: 0 }} dir={theme.direction}>{!disabled && tabValue === 12 ? <Diagnose onFetchPCProduct={onFetchPCProduct} translations={translations} tabValue={tabValue} permissions={permissions} productID={searchParams.productID} ProductType={"work"} /> : <ProductDontLoading />}</TabContainer> </TabPanel> : <></>}

                    </> : null

            }
            </>}
            {redirectOptions.open ?
                <StatisticModal open={redirectOptions.open}
                                product={redirectOptions.product}
                                handleChangeCustomer={() => handleChangeCustomer(onChangeActiveCustomer, redirectOptions)}
                                handleCloseSafe={() => setRedirectOptions({
                                    ...redirectOptions,
                                    open: !redirectOptions.open
                                })}
                                translations={translations} activeCustomer={activeCustomer} />
                : null}
        </div >
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        pcProducts: state.product.pcProducts,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []

    };
}

const mapDispatchToProps = dispatch => {
    return {
        onCleanBaseboard: () => dispatch(baseboardActions.cleanState()),
        onCleanBattery: () => dispatch(batteryActions.cleanState()),
        onCleanCpu: () => dispatch(cpuActions.cleanState()),
        onCleanGpu: () => dispatch(gpuActions.cleanState()),
        onCleanMemory: () => dispatch(memoryActions.cleanState()),
        onCleanNic: () => dispatch(nicActions.cleanState()),
        onCleanStorage: () => dispatch(storageActions.cleanState()),
        onGenerateReportPc: (pcProduct, translations, ErasureReportType) => dispatch(pcProductActions.generateReport(pcProduct, translations, ErasureReportType)),

        onFetchPCProduct: product => dispatch(pcProductActions.loadPCProduct(product)),
        onEditPCProduct: product => dispatch(pcProductActions.editPCProduct(product)),
        onFetchPCGrades: product => dispatch(pcProductActions.fetchGrades(product)),
        onFetchPCGradingCategories: product => dispatch(pcProductActions.fetchGradingCategories(product)),
        onFetchPCTypicalProblems: (id) => dispatch(pcProductActions.fetchTypicalProblems(id)),
        onDeletePCProduct: (product) => dispatch(pcProductActions.deletePCProduct(product)),
        onPCDownload: (productID, customerID) => dispatch(pcProductActions.downloadRawData(productID, customerID)),
        pcProductEditInit: (id) => dispatch(pcProductActions.loadPCProductInit(id)),
        fetchPCOrders: (id) => dispatch(pcProductActions.fetchOrders(id)),
        movePCToAnotherPalette: data => dispatch(pcProductActions.moveToAnotherPalette(data)),
        fetchCollies: (id) => dispatch(pcProductActions.fetchCollies(id)),
        productEditable: data => dispatch(pcProductActions.productEditable(data)),
        onUnpairExternalPC: externalID => dispatch(pcProductActions.unpairExternalPC(externalID)),
        onUnpairBulkExternalPC: externalIDs => dispatch(pcProductActions.unpairBulkExternalPC(externalIDs)),
        onCleanPCState: () => dispatch(pcProductActions.cleanState()),
        onChangeActiveCustomer: (customerID, path) => dispatch(action.changeActiveCustomer(customerID, path)),

        onUpdatePresets: data => dispatch(pcProductActions.updatePresets(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ProductComponents));
